import mockData from './mockData'
import { isMiniProgram, sendLog } from '@/utils/index'
const ua = navigator.userAgent
// 初始化对象
if (!hcApp.isHCApp()) {
  console.info('---------- 非恒驰App环境，启用mock数据2 ------------')
  if (ua.toLowerCase().indexOf('android') > -1) {
    window.HCwebviewBridge = {
      postMessage: postMessage,
    }
  } else {
    // 保存一下原始引用，在调用mock的postMessage方法时，优先使用原始引用下的postMessage。当userAgent没有hengchi标志时，且又是在ios恒驰app内，会走此逻辑
    if (!window.webkit?.messageHandlers?.HCwebviewBridge) {
      // mock webkit对象，这么写的原因是，js sdk里面会使用这个对象（hcApp.postMessage）
      window.webkit = {
        messageHandlers: {
          HCwebviewBridge: {
            postMessage: postMessage,
          },
        },
      }
    }
  }
}

function postMessage(params) {
  if (typeof params === 'string') {
    params = JSON.parse(params)
  }
  isMiniProgram().then((result) => {
    if (result) {
      return new Promise((resolve) => {
        resolve(mockData[params.methodName] || {})
      })
    } else if (window.originalWebkit) {
      // 优先使用原始对象
      window.originalWebkit.messageHandlers.HCwebviewBridge.postMessage(params)
      console.log('使用了原始对象:', params.methodName)
      sendLog({
        type: `originalWebkit call ${params.methodName}`,
      })
    } else {
      setTimeout(() => {
        const _mockData = mockData[params.methodName]
        typeof window[params.callback] === 'function' && window[params.callback](_mockData || {})
      }, 500)
    }
  })
}
